if(!customElements.get('quote-image')) {
  
  class QuoteImage extends HTMLElement {
    constructor() {
      super();

      this.timeout = null;

      this.addEventListener("mouseenter", () => {
        this.mouseEnter();
      });

      this.addEventListener("mouseleave", () => {
        this.mouseLeave();
      });
    }

    mouseEnter() {
      clearTimeout(this.timeout);
      this.classList.add('is-zoomed');
    }

    mouseLeave() {
      this.timeout = setTimeout(() => {
        this.classList.remove('is-zoomed');
      }, 500);
    }

  }

  window.QuoteImage = QuoteImage;
  customElements.define('quote-image', QuoteImage);
}